import { render, staticRenderFns } from "./BeitragswaehlerGroup.vue?vue&type=template&id=7b34bd32&scoped=true&"
import script from "./BeitragswaehlerGroup.vue?vue&type=script&lang=js&"
export * from "./BeitragswaehlerGroup.vue?vue&type=script&lang=js&"
import style0 from "./BeitragswaehlerGroup.vue?vue&type=style&index=0&id=7b34bd32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b34bd32",
  null
  
)

export default component.exports